import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Image, Typography, Table, Card ,Tag,Space} from 'antd';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import {BankOutlined,UserOutlined} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import {MAINAPIURL,APPBACKGROUND_COLOR} from '../appsettings.js';
ChartJS.register(ArcElement, Tooltip, Legend);
const { Content } = Layout;
const { Title, Text } = Typography;


function Dashboard() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const USER_DNAME = localStorage.getItem("USERDPNAME");
    const USER_ROLE = localStorage.getItem("USERDESIGNATION");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const navigate = useNavigate();
    const [downtimeSummary, setDowntimeSummary] = useState(null);
 
    useEffect(() => {

            
        
    }, []);

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >

                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Row>
                        <Col xs={24} md={12} padding={10}>
                                <Tag style={{fontSize:"20px",padding:"8px"}} icon={<BankOutlined />} color="cyan">Ceylonika Cosmetics (Pvt) Ltd</Tag>
                        </Col>

                        <Col xs={24} md={12} padding={10} style={{textAlign:"right"}}>
                                <Tag style={{fontSize:"20px",padding:"8px"}} icon={<UserOutlined />} color="magenta">{USER_DNAME} <small>({USER_ROLE})</small></Tag>
                        </Col>

                    </Row>
                    
                </div>
            </Content>
            <Footerdiv />
        </Layout>
    );
}

export default Dashboard;